import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { formatNumber } from "@/utils/format";
import { getAmount } from "@/utils/number";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import ShallowSeaTerrainTileEntity from "./ShallowSeaTerrainTileEntity";

type FishableFrameNames =
	| FrameName.SHALLOW_SEA_SMALL_FISH
	| FrameName.SHALLOW_SEA_MEDIUM_FISH
	| FrameName.DEEP_SEA_MEDIUM_FISH
	| FrameName.DEEP_SEA_BIG_FISH;

class ShallowSeaSmallFishTerrainTileEntity extends ShallowSeaTerrainTileEntity {
	public static readonly frameName: FishableFrameNames =
		FrameName.SHALLOW_SEA_SMALL_FISH;

	public get description(): string {
		return super.description.replace(
			"{number}",
			formatNumber(
				getAmount(
					this.config.production.get(
						ResourceType.PRODUCTION_RESOURCE_UNIT,
					)! as number,
				) / 2, // 2 - produkcia z malych ryb
			),
		);
	}
	public get exploreCoefficient(): number | null {
		let exploreCoefficient = super.exploreCoefficient || 0;

		exploreCoefficient -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.pirate_navigation,
		);
		return Math.max(exploreCoefficient, 0);
	}
}

export default ShallowSeaSmallFishTerrainTileEntity;
